import { render, staticRenderFns } from "./SwipeableBar.vue?vue&type=template&id=1bac122e&lang=pug&"
import script from "./SwipeableBar.vue?vue&type=script&lang=ts&"
export * from "./SwipeableBar.vue?vue&type=script&lang=ts&"
import style0 from "./SwipeableBar.vue?vue&type=style&index=0&id=1bac122e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports